import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import type { DashboardT } from 'business/definitions';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CreateDashboardModal from './CreateDashboardModal';

type Props = {
    onCreate?: (arg1: DashboardT) => void;
};

const CreateDashboardButton = ({ onCreate = () => {} }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <>
            <Button
                onClick={() => setIsOpen(true)}
                variant="contained"
                sx={{ m: `${theme.spacing(1)} 0` }}
            >
                {t('home.createDashboard')}
            </Button>
            {isOpen && (
                <CreateDashboardModal
                    isOpen={isOpen}
                    onCreate={onCreate}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
};

export default CreateDashboardButton;
